exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4f84bd5c] h1{font-size:65px;font-family:SFPro;line-height:1.1;font-weight:700;color:#000}[data-v-4f84bd5c] h2,h3[data-v-4f84bd5c]{font-family:SFProBold}[data-v-4f84bd5c] h2{font-size:28px}[data-v-4f84bd5c] h3{font-size:20px}.submit-button[data-v-4f84bd5c]{color:#fff!important;line-height:1.45!important;font-weight:700!important;font-size:18px!important;text-transform:none!important;-webkit-box-shadow:none!important;box-shadow:none!important;height:56px;width:100%;background-color:#00ba57!important;text-align:center;vertical-align:middle;padding:0!important;margin:0;border-radius:100px;border:1px solid transparent}.submit-button[data-v-4f84bd5c] .v-btn__content{white-space:pre-wrap;margin:16px 0 0;line-height:1.1}.logo[data-v-4f84bd5c]{max-width:100%;width:200px}.logo-sm[data-v-4f84bd5c]{max-width:200px;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f84bd5c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/b2b/ManageLink.vue
// module id = SSmt
// module chunks = 0